import React from 'react'
import PropTypes from 'prop-types'

import { useTCF } from 'components/TCFProvider'

import Styles from './styles.scss'

import ImpressumLink from '../../../../ImpressumLink'

import AgreeToUseParagraph from './AgreeToUseParagraph'
import PurposesParagraph from './PurposesParagraph'
import VendorParagraph from './VendorParagraph'


export default function TCFConsentMessage(props) {
  const {
    handleShowDocument,
    handleShowPreferences,
  } = props

  const { gvl } = useTCF()

  return (
    <>
      <p className={ Styles.p }>
        <VendorParagraph />
      </p>
      <p className={ Styles.p }>
        <AgreeToUseParagraph
          handleShowDocument={ handleShowDocument }
          handleShowPreferences={ handleShowPreferences }
        />
      </p>
      { renderPurposesAndSpecialFeatures(gvl) }
      <p className={ Styles.p }>
        <ImpressumLink />
      </p>
    </>
  )
}

TCFConsentMessage.propTypes = {
  handleShowDocument: PropTypes.func.isRequired,
  handleShowPreferences: PropTypes.func.isRequired,
}

function renderPurposesAndSpecialFeatures(gvl) {
  const purposes = gvl.getPurposes()
  const specialFeatures = gvl.getSpecialFeatures()

  if ( !purposes?.length && !specialFeatures?.length ) {
    return
  }

  return (
    <p className={ Styles.p }>
      <PurposesParagraph
        purposes={ purposes }
        specialFeatures={ specialFeatures }
      />
    </p>
  )
}
